const common = {
	// Common
	username: 'Nombre de usuario',
	password: 'Contraseña',
	firstName: 'Nombre',
	lastName: 'Apellido',
	email: 'Email',
	accept: 'Aceptar',
	cancel: 'Cancelar',
	close: 'Cerrar',
	create: 'Crear',
	delete: 'Eliminar',
	edit: 'Editar',
	details: 'Detalles',
	filter: 'Filtrar',
	add: 'Agregar',
	general: 'General',
	go: 'Ir',
	open: 'Abrir',
	reload: 'Recargar',
	save: 'Guardar',
	search: 'Buscar',
	watch: 'Ver',
	selected: 'seleccionados',
	upload: 'Subir',
	success: 'Se guardó correctamente',
	successSync: 'Sincronizacion exitosa',
	failSync: 'Algunos datos no se sincronizaron correctamente',
	errorSync: 'Error al sincronizar',
	download: 'Descargar',
	densePadding: 'Fila densa',
	rowsPerPage: 'Líneas por página',
	findUser: 'Busque un usuario ...',
	import: 'Importar',
	importingPleaseWait: 'Por favor espere, importando',
	more: 'Más',
	code: 'Código',
	loading: 'Cargando, por favor espere...',
	role: 'rol',
	role_admin: 'Administrador',
	role_panel: 'Usuario de panel',
	role_parkingAdmin: 'Administrator "estacionamiento"',
	role_parkingCashier: 'Cajero "estacionamiento"',
	role_parkingGate: 'Estacionamiento "puerta"',
	role_user: 'Cliente',
	role_barAdmin: 'Administrador "bar"',
	role_barPanel: 'Editor "bar"',
	role_barCashier: 'Cajero "bar"',
	role_inAppSaleAdmin: 'Administrador "balneario"',
	role_qrGenerator: 'Generador de QR',
	role_barGuest: 'Invitado "bar"',
	role_report: 'Usuario de reportes',
	role_nfcAdmin: 'Administrador "tarjetas NFC"',
	published: 'Publicado',
	active: 'Activo',
	inactive: 'Inactivo',
	draft: 'Borrador',
	ListSoldProducts: 'Listado por productos',
	ProductsSoldByLocation: 'Productos por locacion',
	ProductsSoldByVendor: 'Productos por usuarios internos',
	tableNumber: 'Numero de mesa',
	canceled: 'Cancelado',
	selectFile: 'Seleccionar archivo',
	fileError: 'Formato de archivo no soportado',
	importSuccess: 'Archivo importado correctamente',
	language: 'Idioma',
	spanish: 'español',
	english: 'inglés',
	valueTo: 'Hasta',
	$lte: 'Menor o igual a',
	$gte: 'Mayor o igual a',
	backOfficeDocumentationTitle: 'Documentación del panel',
	backOfficeDocumentationDescription: 'Link a documentación sobre el uso del panel',
	itDocumentationTitle: 'Documentación IT',
	itDocumentationDescription: 'Link a documentación sobre la configuración del servidor',
	welcome:
		'Bienvenido {{name}}, si necesitás ayuda con el uso del panel, o con alguna configuración del servidor, puedes acceder a la documentación con los links de abajo.',
	welcomeClient: 'Bienvenido {{name}}',
	export: 'Exportar',
	tokenExpired: 'Tu sesión ha expirado, por favor ingrese nuevamente su usuario y contraseña',
	serverIsDown: 'El servidor se encuentra inactivo, por favor contacte al departamento de sistemas para más ayuda',
	followingElementsWithError:
		'Los siguientes elementos con la columna "{{key}}" ({{elements}}) no pudieron ser creados, error: {{error}}',
	status: 'Estado',
	deleteTitle: 'Eliminación',
	deleteText: '¿Está seguro que desea eliminar el elemento seleccionado?',
	cancelDescription: '¿Está seguro que desea regresar a la pantalla de login?',
	exampleFile: 'Descargar un archivo .csv de ejemplo',
	account: 'cuenta',
	account_plural: 'cuentas',
	dashboard: 'escritorio',
	favorite: 'favorito',
	favorite_plural: 'favoritos',
	inbox: 'buzón de entrada',
	personal_area: 'Perfil',
	profile: 'perfil',
	user: 'usuario',
	user_plural: 'usuarios',
	panel_user_plural: 'Usuarios (internos)',
	shorcuts: 'Accesos directos',
	order: 'Orden',
	link: 'Enlace',
	app_user_plural: 'Usuarios (App)',
	user_me: 'mis datos',
	userTitle: 'datos de {{name}}',
	resetPassword: 'Blanquear contraseña',
	resetPasswordTitle: 'Blanquear contraseña',
	resetPasswordText: '¿Desea blanquear la contraseña del usuario seleccionado?',
	creationPasswordText:
		'La primera vez que el usuario inicie sesión creará su contraseña la cual será utilizada en los acesos siguientes.',
	client: 'Cliente',
	client_plural: 'Clientes',
	loginDate: 'Último ingreso',
	loadError: 'Hubo un problema al intentar cargar los datos',
	clientTitle: 'Clientes',
	identifier: 'Identificador',
	companyName: 'Nombre de la compañía',
	city: 'Ciudad',
	address: 'Dirección',
	phone: 'Teléfono',
	phoneNumber: 'Numero de Telefono',
	alternativeEmail: 'Email alternativo',
	associationLabel: 'Asociación de Marca',
	position: 'Position',
	area: 'Area',
	actions: 'Acciones',
	data: 'Datos',
	contact: 'Contacto',
	mode: 'Modo',
	date: 'Fecha',
	range: 'Rango',
	from: 'Desde',
	to: 'Hasta',
	to2: 'al',
	website: 'Sitio web',
	users: 'Usuarios',
	crm: 'CRM',
	bill: 'factura',
	bill_plural: 'facturas',
	person: 'persona',
	person_plural: 'personas',
	document: 'documento',
	document_plural: 'documentos',
	main: 'principal',
	documentation: 'documentación',
	dates: 'Fechas',
	contacts: 'Contactos',
	remove: 'remover',
	total: 'Total',
	solds: 'Vendidos',
	type: 'Tipo',
	plate: 'Patente',
	successCount: 'Procesos exitosos',
	message: 'Mensaje',
	collected: 'Recaudado',
	process_sync: 'Proceso sinc.',
	date_process_sync: 'Fecha proceso sinc.',
	date_mov_sync: 'Fecha movimiento sinc.',
	entry: 'Ingreso',
	exit: 'Salida',
	user_process_sync: 'Usuario proceso sinc.',
	total_mov_sync: 'Total movimientos',
	success_mov_sync: 'Movimientos exitosos',
	products: 'Productos',
	services: 'Servicios',
	SoldProducts: 'Venta de Productos',
	location: 'Locacion',
	error_mov_sync: 'Movimientos con error',
	reportSync: 'Reporte de sinc.',
	occupations: 'Ocupaciones',
	quantity: 'Cantidad',
	currentPrices: 'Precios vigentes',
	action: 'Acción',
	transfer: 'Transferencia',
	cash: 'Efectivo',
	pending: 'Pendiente',
	accepted: 'Aceptado',
	rejected: 'Rechazado',
	place: 'Lugar',
	place_plural: 'Lugares',
	createPlace: 'Crear lugar',
	name: 'Nombre',
	opening: 'Apertura',
	closes: 'Cierre',
	barClosure: 'Cierre de barras',
	doorClosure: 'Cierre de puertas',
	mapsLink: 'Enlace Mapa',
	createEvent: 'Crear event',
	createArtist: 'Create artist',
	eventTitle: 'Editar evento ({{title}})',
	artistTitle: 'Edit artist ({{title}})',
	currentPlaceNeeded: 'Primero debes crear un "lugar"',
	ticketsLink: 'Link a tiketera',
	tiktokEmbedded: 'Embebido de Tiktok',
	featured: 'Destacado',
	isFeatured: 'Es destacado',
	app_event_plural: 'Eventos',
	deletePlaceWithEvents: 'No se pueden eliminar lugares con eventos',
	featuredPosition: 'Posición destacada',
	setFeatured: 'Destacar',
	unsetFeatured: 'Quitar',
	tag: 'Tag',
	title: 'Título',
	featured_plural: 'Destacados',
	all: 'Eventos',
	vendor: 'Usuario interno',
	everyone: 'Todos',
	typeoOfLocation: 'Locacion',
	typeOfVendor: 'Usuario interno',
	up: 'Subir',
	down: 'Bajar',
	image: 'Imagen',
	uploadingPleaseWait: 'Subiendo, por favor espere.',
	uploadingError: 'El archivo no pudo ser subido.',
	lineup: 'Lineup',
	deleteWithLikesWarning: 'El elemento seleccionado posee LIKES, ¿Está seguro que desea continuar?',
	artist_plural: 'Artistas',
	artist: 'Artista',
	genre: 'Género',
	tentOccupancy: 'Ocupacion de carpas',
	tent: 'Carpa',
	cars: 'Autos',
	availableParking: 'Cocheras disponibles',
	genre_plural: 'Géneros',
	textBottom: 'Texto del boton',
	color: 'Color',
	instagramEmbedded: 'Embebido de instagram',
	parking_vehicles: 'Tipo de vehículos',
	parking_gate: 'Estacionamiento',
	parking_cashier: 'Est. Cobros',
	parkings: 'Cocheras',
	parkingOccupancy: 'Ocupacion cocheras',
	occupancyParking: 'Ocupacion parking',

	vehicle_code: 'Código',
	description: 'Descripción',
	priceHour: 'Precio por hora',
	priceHalfStay: 'Precio por media estadía',
	priceStay: 'Precio por estadía',
	continue: 'Continuar',
	confirm: 'Confirmar',
	any: 'Cualquiera',
	faq: 'Preg. frecuentes',
	appConfig: 'Configuración',
	conditionsUrl: 'URL Condiciones',
	policyUrl: 'URL política',
	privacyUrl: 'URL privacidad',
	deletionUrl: 'URL de eliminación',
	mapsLinkLabel:
		'Puedes copiar la URL del iframe de Google Maps o copiar todo el código HTML. El sistema recuperará automáticamente la URL y, si el código es correcto, el iframe aparecerá automáticamente.',
	instagramLinkLabel:
		'Puedes copiar la URL del iframe de Instagram o copiar todo el código HTML. El sistema recuperará automáticamente la URL. Puedes comprobar la validez del link accediendo al botón "Comprobar Link".',
	checkLink: 'Comprobar Link',
	question: 'Pregunta',
	response: 'Respuesta',
	withoutElements: 'No hay elementos existentes, para crear uno nuevo por favor presionar el botón "Crear"',
	createFaq: 'Crear pregunta frecuente',
	editFaq: 'Editar pregunta frecuente',
	publishTitle: 'Publicar evento',
	publishDescription: '¿Está seguro que desea publicar el evento seleccionado?',
	publishError: 'El evento seleccionado no pudo ser publicado',
	unpublishTitle: 'Despublicar evento',
	unpublishDescription: '¿Está seguro que desea despublicar el evento seleccionado?',
	unpublishError: 'El evento seleccionado no pudo ser despublicar',
	publish: 'Publicar',
	unpublish: 'Despublicar',
	view: 'Ver',

	featuredDraftError:
		'Los eventos destacados sólo pueden ser eventos publicados, para agregar un evento a destacados primero debes publicarlo.',
	notifications: 'Notificaciones',
	createNotification: 'Crear notificación',
	artistNewDates: 'Artistas',
	cancelation: 'Cancelaciones',
	custom: 'Personalizadas',
	eventChanges: 'Eventos',
	allValues: 'Todo',
	topic: 'Tema',
	cancelEventError: 'El evento no pudo ser cancelado',
	cancelEventTitle: 'Cancelar evento',
	cancelEventDescription: '¿Estás seguro que deseas cancelar el evento seleccionado?',
	selectArtist: 'Seleccionar artista',
	QRCodes: 'Códigos QR',
	category: 'Categoría',
	categories: 'Categorías',
	important: 'Importante',
	sendNotification: 'Enviar Notificacion',
	msjNotification: 'Sólo se enviarán notificaciones cuando cancele un evento o publique un evento modificado.',
	msjNotificationEspecial:
		'Sólo se enviará una notificación si se modifico el título, se reprogramo la fecha o se actualizo el lineup.',
	msjNotificationConfirm: 'La notificacion solo se enviara si hubo una modificacion en el evento.',
	of: 'de',
	price: 'Precio',
	changes: 'Cambios',
	promotionPrice: 'Precio (promo)',
	merch: 'Mercancía',
	product: 'Producto',
	bar: 'Barra',
	yes: 'Si',
	no: 'No',
	OTHER: 'otra',
	PARKING: 'parking',
	TENT: 'carpa',
	BAR: 'barra',
	candidates: 'Candidatos',
	comments: 'Comentarios',
	comment: 'Comentario',
	events: 'Eventos',
	beach: 'Playa',
	onBoardingUrl: 'URL Onboarding',
	muteHelpPhone: 'Teléfono de ayuda (MUTE)',
	walletHelpPhone: 'Teléfono de ayuda (WALLET)',
	onBoardingUrlHelp:
		'POR FAVOR, VERIFICA CUIDADOSAMENTE ANTES DE MOFICIAR LA URL DE ONBOARDING. Si la misma está mal formada el proceso de onboarding en la App no funcionará. Ten en cuenta que la URL de onboarding debe finalizar siempre en &.',
	updateOnBoardingUrl: 'Actualizar URL de Onboarding',
	refundUrlHelp:
		'POR FAVOR, VERIFICA CUIDADOSAMENTE ANTES DE MOFICIAR LA URL DE DEVOLUCIÓN. Si la misma está mal formada el proceso de devolución no funcionará.',
	updateRefundUrl: 'Actualizar URL de devolución',
	refundUrl: 'URL de devolución',
	appVersionHelp:
		'POR FAVOR, VERIFICÁ CUIDADOSAMENTE ANTES DE MODIFICAR LAS VERSIONES. Si están mal formadas, el proceso de exigir la actualización de la App no funcionará. Ingresá la versión publicada en la tienda, con formato X.Y.Z (por ejemplo 4.1.2): es la del tag del build (staging/vX.Y.Z o production/vX.Y.Z). Las apps con una versión menor verán el aviso de actualización.',

	isActive: 'Activo',
	emailSent: 'Pendiente',
	loggedOut: 'Sesión cerrada',

	// Wallet operations pending human resolution
	walletOperations: 'Operaciones de billetera',
	walletOperationsSubtitle:
		'Compras y devoluciones donde el proveedor pudo haber movido el dinero y no pudimos confirmarlo.',
	walletOperationsFilterAll: 'Todas',
	walletOperationsEmpty: 'No hay operaciones que coincidan con lo que buscaste.',
	walletOperationsTotalFloor: 'Hay más de {{total}} operaciones que cumplen el filtro.',
	walletOperationsFailed:
		'No se pudo leer el listado: esto no quiere decir que no haya operaciones. Revisá la búsqueda y volvé a intentar.',
	walletOperationsQueueReview: 'Requieren revisión',
	walletOperationsQueueReviewHelp:
		'El sistema dejó de consultar al proveedor y no pasa nada más hasta que una persona decida. Son las que hay que resolver.',
	walletOperationsQueueChecking: 'Esperando al proveedor',
	walletOperationsQueueCheckingHelp:
		'El sistema todavía le está preguntando al proveedor por estas operaciones. Por ahora no hay nada que hacer.',
	walletOperationsQueueClosed: 'Cerradas',
	walletOperationsQueueClosedHelp:
		'Ya no están abiertas: las confirmó o las rechazó el sistema, o las cerró una persona. Acá se encuentran las resoluciones manuales, con quién decidió, cuándo y por qué.',
	walletOperationsQueueAll: 'Todas',
	walletOperationsQueueAllHelp:
		'Todas las operaciones, en cualquier estado. Usá esta pestaña cuando no sepas cómo terminó la que te están preguntando.',
	walletOperationsFilters: 'Buscar una operación',
	walletOperationsFiltersClear: 'Limpiar la búsqueda',
	walletOperationsFiltersClearAction: 'Limpiar',
	walletOperationsFiltersHelp:
		'Los usuarios se buscan exactos, no por una parte del nombre. Las fechas son sobre el inicio de la operación y toman los días completos en hora local.',
	walletOperationsFilterSubject: 'Cliente (usuario)',
	walletOperationsFilterActor: 'Cobró (usuario)',
	walletOperationsFilterUsernameHelp: 'Tal cual, sin abreviar.',
	walletOperationsFilterAmountMin: 'Monto desde',
	walletOperationsFilterAmountMax: 'Monto hasta',
	walletOperationsFilterFrom: 'Iniciada desde',
	walletOperationsFilterTo: 'Iniciada hasta',
	walletOperationsAmountInvalid: 'El monto tiene que ser un número de cero o más.',
	walletOperationsAmountRangeInvalid: 'El monto desde no puede ser mayor que el monto hasta.',
	walletOperationsDateInvalid: 'Revisá las fechas: alguna no es una fecha válida.',
	walletOperationsDateRangeInvalid: 'La fecha desde no puede ser posterior a la fecha hasta.',
	walletOperationLocked: 'La tiene otra persona',
	walletOperationLockedHelp:
		'Otra persona la está resolviendo en este momento. Esperá a que termine y recargá antes de tocarla.',
	walletOperationNotPollable: 'Sin identificador del proveedor',
	walletOperationNotPollableHelp:
		'La solicitud nunca devolvió un identificador del proveedor, así que no hay nada que volver a consultar: buscá el movimiento a mano y después completala o cerrala.',
	walletOperationId: 'ID de operación',
	walletOperationKind: 'Tipo',
	walletOperationKindCharge: 'Compra',
	walletOperationKindRefund: 'Devolución',
	walletOperationKindPostnetIntention: 'Compra con Postnet',
	walletOperationKindTransferCardholder: 'Transferencia a titular',
	walletOperationKindTransferCbu: 'Transferencia a CBU',
	walletOperationSubject: 'Cliente',
	walletOperationActor: 'Cobró',
	walletOperationAmount: 'Monto',
	walletOperationCreatedAt: 'Iniciada',
	walletOperationFirstSentAt: 'Primer envío',
	walletOperationLastAttemptAt: 'Último intento',
	walletOperationAttempts: 'Intentos',
	walletOperationPolls: 'Consultas al proveedor',
	walletOperationNextPollAt: 'Próxima consulta',
	walletOperationState: 'Estado',
	walletOperationStateClaimed: 'Tomada',
	walletOperationStatePrepared: 'Preparada',
	walletOperationStateSent: 'Enviada',
	walletOperationStateSettled: 'Completada',
	walletOperationStateFailed: 'Rechazada',
	walletOperationStateUnresolved: 'Sin resolver',
	walletOperationStateResolved: 'Resuelta a mano',
	walletOperationOutcome: 'Respuesta del proveedor',
	walletOperationOutcomeApproved: 'Aprobada',
	walletOperationOutcomeRejected: 'Rechazada',
	walletOperationOutcomePending: 'Pendiente',
	walletOperationOutcomeUnknown: 'Desconocida',
	walletOperationOutcomeNone: 'Sin respuesta',
	walletOperationStage: 'Situación',
	walletOperationStageChecking: 'Confirmando',
	walletOperationStageUnresolved: 'Requiere revisión',
	walletOperationReason: 'Por qué se detuvo',
	walletOperationReasonNone: 'Sin motivo registrado',
	walletOperationProvider: 'Proveedor',
	walletOperationEndpoint: 'Operación en el proveedor',
	walletOperationLoadType: 'Movimiento',
	walletOperationOrderId: 'ID de orden',
	walletOperationIntent: 'Detalle de la operación',
	walletOperationAmountPaid: 'Pagado',
	walletOperationPoints: 'Puntos usados',
	walletOperationPaymentMethod: 'Medio de pago',
	walletOperationSection: 'Sección',
	walletOperationProducts: 'Productos',
	walletOperationNoProducts: 'La operación no tiene productos.',
	walletOperationIntentRaw: 'Datos completos',
	walletOperationDetailTitle: 'Operación {{id}}',
	walletOperationNotFound: 'No se pudo leer la operación.',
	walletOperationActions: 'Resolución',
	walletOperationActionComplete: 'Completar manualmente',
	walletOperationActionCompleteHelp:
		'Confirmaste con el proveedor que el dinero se movió: aplica los efectos que la solicitud no pudo aplicar.',
	walletOperationActionCompleteWarning:
		'Se van a aplicar los efectos de la operación (orden, saldo y notificaciones al cliente) como si la solicitud hubiese respondido bien.',
	walletOperationActionResolve: 'Cerrar sin aplicar efectos',
	walletOperationActionResolveHelp:
		'Estableciste que no se movió dinero, o que ya fue devuelto por fuera del sistema: cierra la operación sin aplicar ningún efecto.',
	walletOperationActionRecheck: 'Volver a consultar al proveedor',
	walletOperationActionRecheckHelp:
		'Le vuelve a preguntar al proveedor por esta operación y aplica lo que responda. Queda registrado aunque no responda nada nuevo.',
	walletOperationActionConfirm: '¿Confirmás "{{action}}" sobre esta operación? Motivo: {{reason}}',
	walletOperationActionConfirmNoReason: '¿Confirmás "{{action}}" sobre esta operación?',
	walletOperationActionsNotInReview:
		'Sólo se pueden resolver a mano las operaciones que requieren revisión: ésta ya la está resolviendo el sistema o ya quedó cerrada.',
	walletOperationReasonLabel: 'Motivo de la resolución',
	walletOperationReasonPlaceholder: 'Qué revisaste, con qué dato lo decidiste y dónde lo verificaste.',
	walletOperationReasonRequired:
		'Escribí el motivo antes de resolver: queda registrado con tu usuario y la fecha, es lo que permite revisar después una decisión sobre plata ajena, y la API rechaza la acción sin él.',
	walletOperationReasonHelp: '{{length}} de {{max}} caracteres.',
	walletOperationResolved: 'Operación resuelta: {{result}}',
	walletOperationResolutions: 'Resoluciones manuales',
	walletOperationNoResolutions: 'Nadie resolvió esta operación todavía.',
	walletOperationResolutionAt: 'Fecha',
	walletOperationResolutionAction: 'Acción',
	walletOperationResolutionBy: 'Operador',
	walletOperationResolutionResult: 'Resultado',
	walletOperationResolutionReason: 'Motivo',
	walletOperationResultSettled: 'Se completó',
	walletOperationResultFailed: 'Quedó rechazada',
	walletOperationResultPending: 'Sigue pendiente en el proveedor',
	walletOperationResultResolved: 'Cerrada sin efectos',
	walletOperationRefusedReasonRequired: 'Tenés que indicar el motivo de la resolución.',
	walletOperationRefusedNotInReview:
		'La operación ya no está pendiente de resolución manual: la resolvió otra persona o la cerró el sistema. Recargá el listado.',
	walletOperationRefusedLocked:
		'Otra persona está resolviendo esta operación en este momento. Esperá a que termine y volvé a mirarla.',
	walletOperationRefusedNotPollable:
		'La solicitud nunca devolvió un identificador del proveedor, así que no hay nada que volver a consultar: hay que buscar el movimiento a mano y después completarla o cerrarla.',
	walletOperationRefusedNotSettleable:
		'No sabemos cómo completar este tipo de operación: no se puede resolver desde acá, escalalo al equipo de sistemas.',
	walletOperationRefusedUnknown: 'No se pudo resolver la operación.',
	walletOperationProcedureTitle: 'Cómo buscar la operación en el proveedor',
	walletOperationProcedureIntro:
		'El listado de transacciones del proveedor no devuelve el ID de la operación. Una solicitud que nunca respondió sólo se puede identificar por titular, monto y minuto.',
	walletOperationProcedureStep1:
		'1. Buscá en el proveedor los movimientos del titular de esta operación (el cliente) en la fecha del primer envío.',
	walletOperationProcedureStep2:
		'2. Compará el monto exacto y el minuto del primer envío. Si hay un movimiento que coincide, el dinero se movió; si no hay ninguno, no se movió.',
	walletOperationProcedureStep3:
		'3. Es un criterio, no una confirmación: no hay forma de asociar ese movimiento con esta operación. Dejá registrado quién lo revisó, con qué dato lo decidió y cuándo.',
} as const;

export default common;
